<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> query_stats </span>Statistique &
          récapitulation
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <div @click="makeStartParams" class="buttonAdd">
          <span> Paramètrages des statistiques </span>
        </div>
        <span class="rubriqueTitle">
          {{ manipulateData.typeOfTaxeAll ? "Le" : "" }}
          {{
            manipulateData.valueStat ? manipulateData.valueStat : "Statistique"
          }}
          {{ manipulateData.typeOfTaxeAll ? manipulateData.typeOfTaxeAll : "" }}
          du
          {{
            manipulateData.startDate ? manipulateData.startDate : "--/--/---"
          }}
          au
          {{ manipulateData.endDate ? manipulateData.endDate : "--/--/---" }}

          {{
            manipulateData.typeOfTaxeAll && taxData.totalAmount
              ? " est de " + taxData.totalAmount + " FCFA"
              : ""
          }}

        </span>
<!-- {{  manipulateData.valueStat }} -->
        <div
          v-if="manipulateData.valueStat == 'Estimation du prix de vente produit'"
          class="contentLists"
        >
          <table class="contentListeTable">
            <thead>
              <tr>
                <th>Montant total CFA</th>
                <th>Total quantité</th>
                <th>Estimation du prix unitaire</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ blCoastEstimationValue.totalCfaAmount}}</td>
                <td>{{ blCoastEstimationValue.totalQuantity}}</td>
                <td>{{ blCoastEstimationValue.unitCfaAmountAverage}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <span  v-if="manipulateData.valueStat == 'Estimation du prix de vente produit'" class="rubriqueTitle">Détaille du récapitulatif</span>
        <!-- {{ manipulateData }} -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr v-if="manipulateData.valueStat == 'Tracking de produit'">
                <th v-for="item in tableHeaderForBuyAmount" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr
                v-if="
                  manipulateData.valueStat ==
                  'Estimation du prix de vente produit'
                "
              >
                <th v-for="item in tableHeaderBlProductCoast" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr v-if="manipulateData.valueStat == 'Coût de revient des '">
                <th v-for="item in tableHeaderTaxEstimation" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr
                v-if="manipulateData.valueStat == 'Historique du prix de vente'"
              >
                <th v-for="item in tableHeaderHistoryPrice" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr
                v-if="
                  manipulateData.valueStat ==
                  'Historique du prix de revient (estimations)'
                "
              >
                <th v-for="item in tableHeaderHistoryReturnPrice" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr v-if="manipulateData.valueStat == 'Liste des BL'">
                <th v-for="item in tableHeaderBl" :key="item">{{ item }}</th>
              </tr>

              <tr v-if="manipulateData.valueStat == 'Liste des clients'">
                <th v-for="item in tableHeaderCustomer" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr
                v-if="
                  manipulateData.valueStat == 'Liste des transaction client'
                "
              >
                <th v-for="item in tableHeaderTransaction" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr v-if="manipulateData.valueStat == ''">
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>

              <tr v-if="manipulateData.valueStat == 'Liste des produits'">
                <th v-for="item in tableHeaderProduct" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr v-if="manipulateData.valueStat == 'Liste des magasins'">
                <th v-for="item in tableStoreHeader" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr
                v-if="
                  manipulateData.valueStat ==
                    'Liste des conteneurs déchargés' ||
                  manipulateData.valueStat ==
                    'Liste des conteneurs non déchargés'
                "
              >
                <th v-for="item in tableHeaderConteneur" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr v-if="manipulateData.valueStat == 'Liste des fournisseurs'">
                <th v-for="item in tableSupplierHeader" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr v-if="manipulateData.valueStat == 'Liste des factures'">
                <th v-for="item in tableHeaderFacture" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr v-if="manipulateData.valueStat == 'Liste des contrats'">
                <th v-for="item in tableHeaderContrat" :key="item">
                  {{ item }}
                </th>
              </tr>
              <tr
                v-if="
                  manipulateData.valueStat == 'Liste des bons' ||
                  manipulateData.valueStat == 'Liste des bons payé' ||
                  manipulateData.valueStat ==
                    'Liste des bons en attente de paiement'
                "
              >
                <th v-for="item in tableHeaderCard" :key="item">{{ item }}</th>
              </tr>
              <tr
                v-if="
                  manipulateData.valueStat ==
                    'Liste des commandes en attente de livraison' ||
                  manipulateData.valueStat == 'Liste des commandes livrés'
                "
              >
                <th v-for="item in tableHeaderForCardDetail" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <img
              v-if="manipulateData.valueStat == ''"
              src="../assets/empty1.png"
              alt=""
            />
            <tbody
              v-if="
                manipulateData.valueStat == 'Liste des bons' ||
                manipulateData.valueStat == 'Liste des bons payé' ||
                manipulateData.valueStat ==
                  'Liste des bons en attente de paiement'
              "
            >
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in card"
                :key="item._id"
              >
                <td>
                  {{ item.status }}
                </td>
                <td>
                  {{ item.number }}
                </td>
                <td>
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td>
                  {{ item.totalCartDetail }}
                </td>
                <td>
                  {{ item.amount }}
                </td>
                <td>
                  {{ item.reduction }}
                </td>
              </tr>
            </tbody>

            <tbody
              v-if="
                manipulateData.valueStat ==
                'Estimation du prix de vente produit'
              "
            >
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeRow(item)"
                v-for="item in blCoastEstimation"
                :key="item._id"
              >
                <!-- <td>{{ item.supplier  }}</td> -->
                <td>{{ item.totalContainer }}</td>
                <td>{{ item.tonsQuantity }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.cfaAmount }}</td>
                <td>{{ item.month }}</td>
              </tr>
            </tbody>

            <tbody v-if="manipulateData.valueStat == 'Tracking de produit'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeRow(item)"
                v-for="item in productBuyEstimation"
                :key="item._id"
              >
                <td>{{ item.totalContainer ? item.totalContainer : 0 }}</td>
                <td>{{ item.tonsQuantity ? item.tonsQuantity : 0 }}</td>
                <td>{{ item.quantity ? item.quantity : 0 }}</td>
                <td>{{ item.cfaAmount ? item.cfaAmount : 0 }}</td>
                <td>{{ item.etdMonth ? item.etdMonth : 0 }}</td>
              </tr>
            </tbody>

            <tbody v-if="manipulateData.valueStat == 'Coût de revient des '">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeRow(item)"
                v-for="item in taxData.data"
                :key="item._id"
              >
                <td>{{ item.bl ? item.bl.number : " ---" }}</td>
                <td>
                  {{
                    item.bl && item.bl.transitaire
                      ? item.bl.transitaire.name
                      : " ---"
                  }}
                </td>
                <td>{{ item.bl ? item.bl.eta : " ---" }}</td>

                <td>{{ item.nature ? item.nature : "---" }}</td>
                <td>{{ item.name ? item.name : "---" }}</td>
                <td>{{ item.numberOfDays ? item.numberOfDays : 0 }}</td>
                <td>{{ item.amount ? item.amount : 0 }}</td>
              </tr>
            </tbody>

            <tbody
              v-if="manipulateData.valueStat == 'Historique du prix de vente'"
            >
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeRow(item)"
                v-for="item in priceHistory"
                :key="item._id"
              >
                <td>{{ item.createdAt ? item.createdAt : "" }}</td>
                <td>{{ item.product.name }}</td>
                <td>{{ item.product.type }}</td>
                <td>{{ item.product.unitPrice }}</td>
                <td>{{ item.price }}</td>
                <td>{{ raccourcirTexte(item.product.observation) }}</td>
              </tr>
            </tbody>
            <tbody
              v-if="
                manipulateData.valueStat ==
                'Historique du prix de revient (estimations)'
              "
            >
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeRow(item)"
                v-for="item in unitePriceEstimationHistory"
                :key="item._id"
              >
                <td>{{ item.bl ? item.bl.number : "" }}</td>
                <td>{{ item.product.name }}</td>
                <td>{{ item.product.type }}</td>
                <td>{{ item.product.unitPrice }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ raccourcirTexte(item.product.observation) }}</td>
              </tr>
            </tbody>
            <tbody v-if="manipulateData.valueStat == 'Liste des produits'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeRow(item)"
                v-for="item in productData"
                :key="item._id"
              >
                <td>{{ raccourcirTexte(item.name) }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.unitOfMeasurement }}</td>
                <td>{{ item.unitPrice }}</td>
                <td>{{ raccourcirTexte(item.observation) }}</td>
              </tr>
            </tbody>

            <tbody v-if="manipulateData.valueStat == 'Liste des magasins'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeStoreRow(item)"
                v-for="item in storeData"
                :key="item._id"
              >
                <td>{{ raccourcirTexte(item.name) }}</td>
                <td>{{ item.address }}</td>
                <td>{{ raccourcirTexte(item.responsible) }}</td>
              </tr>
            </tbody>
            <tbody v-if="manipulateData.valueStat == 'Liste des contrats'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in contratData"
                :key="item._id"
              >
                <td @click="editeContratRow(item)">{{ item.number }}</td>
                <td @click="editeContratRow(item)">
                  {{ item.supplier ? item.supplier.fullName : "" }}
                </td>
                <td @click="editeContratRow(item)">
                  {{ item.supplier ? item.supplier.phones.join("/") : "" }}
                </td>
                <td @click="editeContratRow(item)">
                  {{ raccourcirTexte(item.observation) }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="manipulateData.valueStat == 'Liste des BL'">
              <tr
                @click="editeBlRow(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in blData"
                :key="item._id"
              >
                <td>
                  {{ item.contractDetail ? item.contractDetail.number : "" }}
                </td>
                <td>{{ item.number }}</td>
                <td>{{ item.totalContainer }}</td>
                <td>{{ item.loadingPort }}</td>
                <!-- <td>{{ item.shipName }}</td>
                <td>{{ item.etdPol }}</td> -->
                <td>{{ item.eta }}</td>
                <td>{{ item.transitaire ? item.transitaire.fullName : "" }}</td>
                <td>{{ item.transitaireAmount }}</td>
                <td>{{ item.totalAmount }}</td>
              </tr>
            </tbody>

            <tbody v-if="manipulateData.valueStat == 'Liste des fournisseurs'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                @click="editeSupplierRow(item)"
                v-for="item in supplierData"
                :key="item._id"
              >
                <td>{{ raccourcirTexte(item.fullName) }}</td>
                <td>{{ item.phones.join("/") }}</td>
                <td>{{ item.email }}</td>
                <td>{{ raccourcirTexte(item.observation) }}</td>
              </tr>
            </tbody>

            <tbody
              v-if="
                manipulateData.valueStat == 'Liste des conteneurs déchargés' ||
                manipulateData.valueStat == 'Liste des conteneurs non déchargés'
              "
            >
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in contenuerAllData"
                :key="item._id"
              >
                <td>{{ item.name }}</td>
                <td>{{ item.containType ? item.containType.name : "" }}</td>
                <td>{{ item.product ? item.product.name : "" }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.store ? item.store.name : "" }}</td>
                <td>{{ item.observation }}</td>
              </tr>
            </tbody>

            <tbody v-if="manipulateData.valueStat == 'Liste des factures'">
              <tr v-for="item in contratDataDetails" :key="item._id">
                <td @click="editNewMinusContrat(item)">
                  {{ raccourcirTexte(item.product ? item.product.name : "") }}
                </td>
                <td @click="editNewMinusContrat(item)">
                  {{ raccourcirTexte(item.number) }}
                </td>
                <td @click="editNewMinusContrat(item)">{{ item.quantity }}</td>
                <td @click="editNewMinusContrat(item)">
                  {{ item.tonsQuantity }}
                </td>
                <td @click="editNewMinusContrat(item)">
                  {{ item.amountInCurrency }}
                </td>
                <td @click="editNewMinusContrat(item)">{{ item.currency }}</td>
                <td @click="editNewMinusContrat(item)">{{ item.amount }}</td>
                <td @click="editNewMinusContrat(item)">
                  {{ item.observation }}
                </td>
                <!-- <td>{{ item.fcl }}</td>
              <td>{{ raccourcirTexte(item.referenceReservation) }}</td> -->
                <!-- <td>{{ raccourcirTexte(item.observation) }}</td> -->
              </tr>
            </tbody>

            <tbody
              v-if="manipulateData.valueStat == 'Liste des transaction client'"
            >
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in customerTransaction"
                :key="item._id"
              >
                <td>
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td>{{ item.createdAt }}</td>

                <td>{{ item.name }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.paymentMethod }}</td>
                <td>{{ item.amount }}</td>
              </tr>
            </tbody>
            <tbody v-if="manipulateData.valueStat == 'Liste des clients'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in customerListData"
                :key="item._id"
              >
                <td>
                  {{ item.company }}
                </td>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ item.phones.join("/") }}
                </td>
                <td>
                  {{ item.email }}
                </td>
                <td>
                  {{ item.address }}
                </td>
                <td>
                  {{ item.role }}
                </td>
                <td>
                  {{ item.wallet.balance }}
                </td>
              </tr>
            </tbody>
            <tbody
              v-if="
                manipulateData.valueStat ==
                  'Liste des commandes en attente de livraison' ||
                manipulateData.valueStat == 'Liste des commandes livrés'
              "
            >
              <tr v-for="item in cardDetails" :key="item._id">
                <td>
                  {{ item.product ? item.product.name : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.type : "" }}
                </td>
                <td>
                  {{ item.product ? item.product.unitPrice : "" }}
                </td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.product.unitPrice * item.quantity }}</td>
                <td>{{ item.reduction }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.store ? item.store.name : "" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Object, // Type de la valeur que vous attendez
      required: true, // Indique que cette prop est requise
    },
  },
  name: "statView",
  components: {},
  data: () => ({
    tableHeader: [
      "Statut",
      "Désignation produit",
      "Quantité",
      "Client",
      "Montant",
      "Observation",
    ],
    tableHeaderConteneur: [
      "Désignation",
      "Type de conteneur",
      "Produit",
      "Contenue estimation quantité",
      "Magasin",
      "Observation",
    ],
    tableHeaderCustomer: [
      "Raison sociale",
      "Nom complet",
      "Contact",
      "Email",
      "Adresse",
      "Type de client",
      "Solde portefeuille",
    ],
    tableHeaderBlProductCoast: [
      // "Fournisseur",
      "Nombre de conteneur",
      "Quantité en tonne",
      "Quantité",
      "Montant CFA",
      "Mois ETD",
    ],

    tableHeaderForBuyAmount: [
      "Total conteneur",
      "Quantité en tonne",
      "Quantité",
      "Montant FCFA",
      "Mois d'arrivée",
    ],


    tableHeaderTransaction: [
      "Client",
      "Date de transaction",
      "Motif de transaction",
      "Type",
      "Mode de paiement",
      "Montant",
    ],
    tableHeaderBl: [
      "Facture",
      "Numéro BL",
      "Nbr de conteneur",
      "Port de chargement",
      "ETA",
      "Transitaire",
      "Montant Transitaire",
      "Montant total",
    ],
    tableHeaderHistoryReturnPrice: [
      "Bl",
      "Produit",
      "Type de produit",
      "Prix unitaire actuel",
      "Prix de revien",
      "Observation",
    ],
    tableHeaderHistoryPrice: [
      "Date d'enregistrement",
      "Produit",
      "Type de produit",
      "Prix unitaire actuel",
      "Prix unitaire historique",
    ],
    tableHeaderCard: [
      "Numéro de Commande",
      "Statut",
      "Clients",
      "Nombre d'articles",
      "Montant Total",
      "Reduction",
    ],
    tableHeaderForCardDetail: [
      "Produit",
      "Type",
      "Prix unitaire",
      "Quantité",
      "Montant de vente",
      "Bonus de fidélité",
      "Montant Total",
      "Magasin",
      // "customerTransaction"
    ],
    tableHeaderTaxEstimation: [
      "Numéro BL",
      "Transitaire",
      "eta",
      "Nature",
      "Désignation",
      "Nombre de jours",
      "Montant",
    ],
    tableHeaderContrat: [
      "Numéro de contrat",
      "Fournisseur",
      "Contact Fournisseur",
      "Observation",
    ],
    tableHeaderFacture: [
      "Produit",
      "N commande",
      "Quantité (sac)",
      "Quantité (tonne)",
      "Montant",
      "Devis",
      "Montant (FCFA)",
      "Observations",
    ],
    tableSupplierHeader: [
      "Nom du fournisseur",
      "Téléphones",
      "Mail",
      "Observation",
    ],
    tableTransitaireHeader: [
      "Nom du Transitaire",
      "Téléphones",
      "Mail",
      "Observation",
    ],
    tableConteneurHeader: ["Type de conteneur", "Description"],
    tableStoreHeader: ["Nom du Magasin", "Adresse", "Nom du responsable"],
    tableUserHeader: ["Role", "Nom complet", "Email", "Intitulé de poste"],
    tableHeaderProduct: [
      "Produit",
      "Type",
      "Unité de mesure",
      "Prix unitaire",
      "Observation",
    ],
    manipulateData: {
      valueStat: "",
      startDate: "",
      endDate: "",
    },
    isSelecteds: [],
    isSelectedAll: false,
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
    value() {
      // alert("ok");
      this.manipulateData = Object.assign(
        {
          valueStat: "",
          startDate: "",
          endDate: "",
        },
        this.value
      );
    },
  },
  computed: {
    ...mapGetters([
      "card",
      "blData",
      "cardDetails",
      "customerListData",
      "customerTransaction",
      "contenuerAllData",
      "contratData",
      "returnStockData",
      "contratDataDetails",
      "productData",
      "supplierData",
      "transitaireData",
      "storeData",
      "userData",
      "conteneurData",
      "priceHistory",
      "unitePriceEstimationHistory",
      "productBuyEstimation",
      "taxData",
      "blCoastEstimation",
      "blCoastEstimationValue",
    ]),
  },
  async mounted() {
    await this.getReturnToStock({});
  },
  methods: {
    ...mapActions([
      "getProduct",
      "getStore",
      "getCustomerList",
      "getReturnToStock",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async makeStartParams() {
      this.$emit("show", true);
      const value = {
        modalType: "makeStartParams",
        valueStat: this.manipulateData.valueStat,
        startDate: this.manipulateData.startDate,
        endDate: this.manipulateData.endDate,
      };
      // await this.getProduct({});
      // await this.getStore({});
      // await this.getCustomerList({});
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "makeStartParams",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async editeReturnStockRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.returnStockData.length; i++) {
          this.returnStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.returnStockData);
        await this.getProduct({});
        await this.getStore({});
        await this.getCustomerList({});
        const value = {
          _id: item._id,
          modalType: "editeReturnStockRow",
          product: item.product ? item.product.name : "",
          store: item.store ? item.store.name : "",
          customer: item.customer ? item.customer.name : "",
          quantity: item.quantity,
          amount: item.amount,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "editeReturnStockRow",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("closeAllModal");
      this.$emit("show", true);
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show", false);
    },
  },
};
</script>
      